define.alias("ember-math-helpers/helpers/cosh", "preview-grid/helpers/cosh");